<template>
  <!-- this component will render a form to be filled by site team which was configured in activity configurator -->
  <div class="pt-10" v-if="activityFormData.activity && activityFormData.activity.id">
    <b-row v-if="enablePreview">
      <div
        class="ml-25 p-5 fw-bold fs-18 col-md-12"
        v-if="activityFormData.activity.showNumericLabels || activityFormData.activity.showNumericLabels == undefined || activityFormData.activity.showNumericLabels == null"
        v-translate:_name="{
          key: activityFormData.activity.id,
          val: lang,
          html: formName
        }"
      >
        {{ formName }}
      </div>
      <div
        v-else
        class="ml-55 p-5 fw-bold fs-18 col-md-12 mr_left-0"
        v-translate:_name="{
          key: activityFormData.activity.id,
          val: lang,
          html: formName
        }"
      >
        {{ formName }}
      </div>
      <b-col v-for="(step, index) in activityFormData.activity.questions" :key="index" cols="12" :class="{ selected: selectedId === step.id }">
        <div
          :id="selectedId === step.id ? selectedId : ''"
          class="fieldCmp"
          :class="{
            _pointer: step.type != 'Section' && step.type != 'SurveyInstruction' && !isHistory && checkForChangeField(step.id)
          }"
        >
          <ActivtiyFormSectionPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Section'"
            :isFieldDisabled="disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />
          <ActivtiyFormNumberPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Number'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />
          <ActivtiyFormBooleanPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Boolean'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
          />
          <ActivtiyFormMultiChoicePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'MultiChoice'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
            :showValidationMessage="showValidationMessage"
            @onValidateAnswer="onValidateAnswer"
            :sendMultiChoiceData="checkSendMultiChoiceData(step.id)"
          />
          <ActivtiyFormTextPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Text'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />
          <ActivtiyFormNumberScalePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'NumberScale'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
          />
          <ActivtiyFormCustomScalePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'CustomScale'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
          />
          <ActivtiyFormVASPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'VAS'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />
          <ActivtiyFormDateTimePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'DateTime'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />
          <ActivtiyFormImageChoicePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Image'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
          />
          <ActivtiyFormInstructionStepPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'SurveyInstruction'"
            :isFieldDisabled="disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />

          <ActivtiyFormDropdownPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'DropDown'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
          />

          <ActivtiyFormLogPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Log'"
            :isFieldDisabled="disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
          />

          <ActivtiyFormIndexPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Index'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />

          <ActivtiyFormMeasurementsPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Measurements'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />

          <ActivtiyFormValidatedEntryPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'ValidatedEntry'"
            :isFieldDisabled="disabledFields[step.id]"
            :trigger-validate="triggerValidation"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />

          <button
            v-if="step.type != 'SurveyInstruction' && step.type != 'Section' && step.type != 'SurveyCompletion' && !isHistory && (canCraAccess || canDmAccess || canPharmacovigilanceAccess || canCraUBAccess || (canCallCenterAccess && showOpenQueryForCallCenter == true))"
            class="btn fw-bold fs-12 btnDisplay btn-outline-primary"
            :id="`open-query-popover-${step.id}`"
            :class="canCraOpenQuery ? 'disable-open-query-button' : 'btn-hover'"
            @click="openQuery(step.id)"
          >
            OPEN A QUERY
          </button>
          <b-popover v-if="canCraOpenQuery" :target="`open-query-popover-${step.id}`" triggers="hover" placement="bottomright"> You cannot open queries on locked activities. </b-popover>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { CRA, DM, PHV, CC, CraUB } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import _ from "lodash";

import ActivtiyFormNumberPreview from "@/components/activity-form/preview-components/activity-form-number-preview.vue";
import ActivtiyFormBooleanPreview from "@/components/activity-form/preview-components/activity-form-boolean-preview.vue";
import ActivtiyFormMultiChoicePreview from "@/components/activity-form/preview-components/activity-form-multi-choice-preview.vue";
import ActivtiyFormTextPreview from "@/components/activity-form/preview-components/activity-form-text-preview.vue";
import ActivtiyFormNumberScalePreview from "@/components/activity-form/preview-components/activity-form-number-scale-preview.vue";
import ActivtiyFormCustomScalePreview from "@/components/activity-form/preview-components/activity-form-custom-scale-preview.vue";
import ActivtiyFormVASPreview from "@/components/activity-form/preview-components/activity-form-vas-preview.vue";
import ActivtiyFormDateTimePreview from "@/components/activity-form/preview-components/activity-form-date-time-preview.vue";
import ActivtiyFormImageChoicePreview from "@/components/activity-form/preview-components/activity-form-image-choice-preview.vue";
import ActivtiyFormInstructionStepPreview from "@/components/activity-form/preview-components/activity-form-instruction-step-preview.vue";
import ActivtiyFormSectionPreview from "@/components/activity-form/preview-components/activity-form-section-preview.vue";
import ActivtiyFormDropdownPreview from "@/components/activity-form/preview-components/activity-form-dropdown-preview.vue";
import ActivtiyFormLogPreview from "@/components/activity-form/preview-components/activity-form-log-preview.vue";
import ActivtiyFormMeasurementsPreview from "@/components/activity-form/preview-components/activity-form-measurements-preview.vue";
import ActivtiyFormIndexPreview from "@/components/activity-form/preview-components/activity-form-index-preview.vue";
import ActivtiyFormValidatedEntryPreview from "@/components/activity-form/preview-components/activity-form-validate-entry-preview.vue";
import * as activityService from "@/components/services/activity-service";
import localStorageService from "@/services/localStorage";

export default {
  components: {
    ActivtiyFormSectionPreview,
    ActivtiyFormNumberPreview,
    ActivtiyFormBooleanPreview,
    ActivtiyFormMultiChoicePreview,
    ActivtiyFormTextPreview,
    ActivtiyFormNumberScalePreview,
    ActivtiyFormCustomScalePreview,
    ActivtiyFormVASPreview,
    ActivtiyFormDateTimePreview,
    ActivtiyFormImageChoicePreview,
    ActivtiyFormInstructionStepPreview,
    ActivtiyFormDropdownPreview,
    ActivtiyFormLogPreview,
    ActivtiyFormMeasurementsPreview,
    ActivtiyFormIndexPreview,
    ActivtiyFormValidatedEntryPreview
  },
  props: {
    formName: null,
    activityFormData: {},
    applyBranchingLogic: {
      default: true
    },
    mode: {
      default: "PREVIEW"
    },
    triggerValidation: {
      type: Boolean,
      default: false
    },
    isHistory: null,
    queryIds: null,
    selectedFieldId: null,
    selectedId: null,
    queries: {
      type: Array
    },
    isNotificationIcon: Boolean,
    createdById: {
      type: String,
      default: ""
    },
    lang: {
      type: String,
      default: "EN"
    },
    showValidationMessage: {
      type: Boolean,
      default: false
    },
    validationCount: {
      type: Number,
      default: 0
    },
    lockStatus: String
  },
  methods: {
    openQuery(id) {
      if (this.canCraOpenQuery) {
        return true;
      }
      this.querySelectedID = id;
      setTimeout(() => {
        const offsetData = document.getElementById(this.selectedId).parentElement;
        this.getOffsetValue = offsetData.offsetTop;
        this.$root.$emit("openQueriesFormOpen", offsetData.offsetTop);
      }, 80);
      this.$emit("openQuery", id, this.getOffsetValue);
      return false;
    },
    checkForChangeField(id) {
      return this.queryIds && this.queryIds.includes(id) && this.hasQueryCreated(id) && this.hasQueryCreated(id).length;
    },
    hasQueryCreated(id) {
      if (this.canCraAccess || this.canCraUBAccess || this.canPharmacovigilanceAccess || this.canDmAccess) {
        return this.queries && this.queries.filter(q => q.fieldId === id);
      }
      const totalQueries = [];
      this.queries &&
        this.queries.filter(query => {
          if (query.fieldId === id) {
            if (query.assigneeId) {
              if (this.user.id === query.assigneeId) {
                totalQueries.push(query);
              }
            } else {
              totalQueries.push(query);
            }
          }
        });
      return totalQueries;
    },
    select(id) {
      if (this.queryIds && this.queryIds.includes(id) && this.hasQueryCreated(id) && this.hasQueryCreated(id).length) {
        this.$emit("selected", id);
      }
    },
    isQueryIdPrsent(id) {
      return this.canCraAccess || this.canCraUBAccess ? this.queries && this.queries.filter(q => q.fieldId === id) : this.queries && this.queries.filter(q => q.fieldId === id && q.assigneeId === this.user.id);
    },
    scrollToId() {
      if (this.selectedId) {
        window.document.getElementById(`${this.selectedId}`).scrollIntoViewIfNeeded(true);
      }
    },
    setErrorFieldsOnEachStep() {
      this.activityFormData.activity.questions.forEach(step => {
        this.$set(step, "hasFieldError", false);
        this.$set(step, "fieldErrorText", "");
      });
    },
    initAnswerChange(step) {
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;

      if (this.applyBranchingLogic && step.branchingConfigured) {
        this.disabledFields = {};
        this.disabledFields = this.branchingLogic.checkLogic(step);
        this.$emit("disabledFields", this.disabledFields);
      }
    },
    onAnswerChange(step) {
      if (step.branchingConfigured) {
        this.nextQuestionSequence = this.branchingLogic.getNextStepSquenceFromId(step, this.activityFormData.activity);
        this.$emit("nextStepSequence", this.nextQuestionSequence);
      }
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;

      if (this.applyBranchingLogic) {
        this.disabledFields = {};
        this.disabledFields = this.branchingLogic.checkLogic(step);
        this.$emit("disabledFields", this.disabledFields);
      }
      this.updateSectionScores();
    },
    onClearAnswer(step) {
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;

      if (this.applyBranchingLogic) {
        this.disabledFields = {};
        this.disabledFields = this.branchingLogic.clearLogic(step);
        this.$emit("disabledFields", this.disabledFields, true);
      }
    },
    updateSectionScores() {
      this.$emit("getQuestionScores", this.activityFormData);
      setTimeout(() => {
          let allQuestions = this.activityFormData.activity.questions;
          this.activityQuestions = allQuestions.map(item => [item]);
      }, 200);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    refresh() {},
    isPacketPending() {
      if (this.$route.name == "study-participant-edc-unschedule-form-reskin" && this.canCallCenterAccess) {
        return true;
      } else {
        return false;
      }
    },
    getCreatedByUserData() {
      if (this.user && this.user.siteIds && this.user.siteIds[0]) {
        const siteId = this.user.siteIds[0];
        this.$api.getSiteTeamFact(this.$route.params.studyId, siteId).then(response => {
          const siteTeamList = response.body;
          const createdByUserData = siteTeamList.filter(el => {
            return this.createdById == el.id;
          });
          if (createdByUserData.length > 0 && Object.keys(createdByUserData[0]).includes("userRole") && (createdByUserData[0].userRole == "CallCenter" || createdByUserData[0].userRole == "HomeHealth")) {
            this.showOpenQueryForCallCenter = true;
          }
        });
      }
    },
    onValidateAnswer(data) {
      const getIndex = this.getValidationDataMultipleChoice.findIndex(dt => dt.id === data.id);
      this.getValidationDataMultipleChoice[getIndex].showValidationMessage = false;
      for (let i = 0; i < this.getValidationDataMultipleChoice.length; i++) {
        const getResult = this.disabledFields[this.getValidationDataMultipleChoice[i].id];
        if (getResult) {
          this.getValidationDataMultipleChoice[i].showValidationMessage = false;
        }
      }
      this.$emit("onValidateAnswer");
    },
    checkSendMultiChoiceData(id) {
      const filterData = this.getValidationDataMultipleChoice.filter(data => data.id === id);
      return filterData[0];
    }
  },
  data() {
    return {
      querySelectedID: null,
      getOffsetValue: null,
      branchingLogic: null,
      activityQuestions: [],
      disabledFields: [],
      enablePreview: false,
      modes: {
        PREVIEW: 0,
        EDIT: 1,
        RESPONSE: 2
      },
      showOpenQueryForCallCenter: false,
      nextQuestionSequence: null,
      getValidationDataMultipleChoice: []
    };
  },
  watch: {
    selectedId: {
      handler() {
        this.scrollToId();
      }
    },
    activityFormData: {
      handler() {
        this.activityFormData.activity = activityService.replacePastXMonthsString(this.activityFormData.activity, this.$route.params.studyId);
        this.branchingLogic = new activityService.Branching(false, this.activityFormData.activity.questions);
        this.enablePreview = true;
        this.getValidationDataMultipleChoice = this.activityFormData.activity.questions.map(data => {
          const obj = {};
          obj.id = data.id;
          obj.type = data.type;
          obj.showValidationMessage = false;
          return obj;
        });
        this.getValidationDataMultipleChoice = this.getValidationDataMultipleChoice.filter(dt => dt.type === "MultiChoice");
      }
    },
    validationCount: {
      handler() {
        this.getValidationDataMultipleChoice = this.getValidationDataMultipleChoice.map(data => {
          const obj = data;
          obj.showValidationMessage = true;
          return obj;
        });
        if (this.activityFormData.activity.questions) {
          _.forEach(this.activityFormData.activity.questions, (value, index) => {
            if (value.optionsIds) {
              if (value.optionsIds.length === 1 && value.optionsIds[0] === null) {
                this.activityFormData.activity.questions[index].optionsIds = [];
              }
            }
          });
        }
      }
    }
  },
  computed: {
    ...mapGetters(["user"]),
    userIsStudyAdmin() {
      return this.user.userRole === "StudyAdmin";
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    stepsMap() {
      const stepsMap = {};
      if (this.activityFormData && this.activityFormData.activity.questions && this.activityFormData.activity.questions.length) {
        this.activityFormData.activity.questions.forEach(step => (stepsMap[step.id] = step));
      }
      return stepsMap;
    },
    canCraOpenQuery() {
      let userObj = localStorageService.getItem("userObj");
      if (userObj.restrictions !== "" && this.lockStatus && this.lockStatus.toLowerCase() === "locked") {
        return !!userObj.restrictions.includes("activity_response_query.open_locked");
      }
      return false;
    }
  },
  mounted() {
    this.getCreatedByUserData();
    if (this.activityFormData.activity) {
      this.activityFormData.activity = activityService.replacePastXMonthsString(this.activityFormData.activity, this.$route.params.studyId);
      this.branchingLogic = new activityService.Branching(false, this.activityFormData.activity.questions);
      this.enablePreview = true;
      this.getValidationDataMultipleChoice = this.activityFormData.activity.questions.map(data => {
        const obj = {};
        obj.id = data.id;
        obj.type = data.type;
        obj.showValidationMessage = false;
        return obj;
      });
      this.getValidationDataMultipleChoice = this.getValidationDataMultipleChoice.filter(dt => dt.type === "MultiChoice");
    }
  }
};
</script>

<style scoped lang="scss">
.col.row {
  margin: 0 -15px !important;
}
.col-row {
  display: flex;
  flex: 0 0 100%;
  max-width: 100%;
}
.btnDisplay {
  top: 10px;
  right: 10px;
  position: absolute;
  border-color: #d3dfe4;
  background-color: #fff;
}
.disable-open-query-button {
  opacity: 0.3;
}
.disable-open-query-button:hover {
  color: #4c8ce4 !important;
  background-color: transparent !important;
}
.btn-hover:hover {
  color: #fff !important;
  background-color: #4c8ce4 !important;
}
.fieldCmp {
  color: #666669;
}
.form-components:last-of-type {
  padding-bottom: 15px;
}
.fieldCmp:hover + .btn-hover,
.btn-hover:hover {
  display: block;
}
.selected {
  background: #f9f9e0;
  border-color: #d3dfe4;
}
@media (min-width: 1024px) and (max-width: 1111px) {
  .mr_left-0 {
    margin-left: 0 !important;
  }
}
</style>
